export const SET_FILTER = "SET_FILTER";
export const RESET_FILTER = "RESET_FILTER";
export const SET_CSUITE = "SET_CSUITE";
export const SET_TABLE_LOAD = "SET_TABLE_LOAD";
